import { useEffect, useState } from 'react';

const DISMISS_KEY = 'pwa_install_dismissed_at';
const DISMISS_DAYS = 7;

const isStandalone = () => window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;
const isIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
const isMobile = () => /android|iphone|ipad|ipod|mobile/i.test(window.navigator.userAgent) || window.innerWidth < 1024;
const recentlyDismissed = () => {
  const at = Number(localStorage.getItem(DISMISS_KEY) || 0);
  return at && Date.now() - at < DISMISS_DAYS * 86400000;
};

// Gère l'invitation d'installation PWA : prompt natif (Android/Chrome) ou consignes iOS.
export const usePwaInstall = () => {
  const [promptEvent, setPromptEvent] = useState(null);
  const [visible, setVisible] = useState(false);
  const [installed, setInstalled] = useState(isStandalone());

  useEffect(() => {
    if (isStandalone() || recentlyDismissed() || !isMobile()) return;
    const onPrompt = (e) => { e.preventDefault(); setPromptEvent(e); setVisible(true); };
    const onInstalled = () => { setInstalled(true); setVisible(false); };
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    if (window.__pwaInstallPrompt) { setPromptEvent(window.__pwaInstallPrompt); setVisible(true); }
    else if (isIos()) setVisible(true);
    return () => { window.removeEventListener('beforeinstallprompt', onPrompt); window.removeEventListener('appinstalled', onInstalled); };
  }, []);

  const install = async () => {
    if (!promptEvent) return;
    promptEvent.prompt();
    const { outcome } = await promptEvent.userChoice;
    if (outcome === 'accepted') setInstalled(true);
    window.__pwaInstallPrompt = null;
    setPromptEvent(null);
    setVisible(false);
  };
  const dismiss = () => { localStorage.setItem(DISMISS_KEY, String(Date.now())); setVisible(false); };

  return { visible: visible && !installed, canPrompt: !!promptEvent, ios: isIos(), install, dismiss };
};
